exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/premium-certificate.js-WebpackMultiOutput";